import { currentBridgeData } from '@databases/database-state/state/bridge-data';
import {
  bridgeIdentityEqual,
  pickBridgeIdentitySnapshot,
  type BridgeIdentitySnapshot,
} from '@databases/database-state/state/bridge-identity-snapshot';
import { container } from '@databases/service-container';
import { subscribe } from 'valtio';

let lastEmittedIdentity: BridgeIdentitySnapshot | null = null;

/**
 * Resets {@link registerBridgeDataValtioWatch} module state; use in tests only.
 */
export function resetBridgeDataValtioWatchStateForTests(): void {
  lastEmittedIdentity = null;
}

/**
 * Subscribe to `currentBridgeData` (Valtio); dispatch `bridgeDatabaseIdentityChanged` on the
 * {@link CoreEventBus} when identity fields change. Seeds from current data on register without
 * emitting so the first post-load mutation compares against the loaded snapshot. Returns teardown
 * (unsubscribe and clear last identity).
 */
export function registerBridgeDataValtioWatch(): VoidFunction {
  const eventBus = container.resolve('EventBus');

  lastEmittedIdentity = pickBridgeIdentitySnapshot(currentBridgeData.data);

  const unsubscribe = subscribe(currentBridgeData, () => {
    const next = pickBridgeIdentitySnapshot(currentBridgeData.data);

    if (lastEmittedIdentity === null) {
      lastEmittedIdentity = next;
      return;
    }

    if (bridgeIdentityEqual(lastEmittedIdentity, next)) {
      return;
    }

    lastEmittedIdentity = next;

    eventBus.dispatch('bridgeDatabaseIdentityChanged', next);
  });

  return () => {
    unsubscribe();

    lastEmittedIdentity = null;
  };
}
